import { useMemo } from 'react';

import type { DeepPartial } from '../types';
import { usePlayerSettingsContext } from './playerSettingsContext';

export function usePlayerSettings() {
  const { settings, setSettings } = usePlayerSettingsContext();

  return useMemo(
    () => ({
      settings,
      setSettings: (next: DeepPartial<typeof settings>) => setSettings(next),
    }),
    [settings, setSettings],
  );
}
